import { useCallback } from 'react';

import { useCurrentFormFactor } from 'js/app/hooks/device/hooks/useMediaQuery';
import useSegmentation from 'js/app/hooks/useSegmentation';

export const useFilterGroup = () => {
    const currentFormFactor = useCurrentFormFactor();
    const segmentation = useSegmentation();

    return useCallback(({
        isEnabled = true,
        formFactor = [],
        ...segmentationRules
    }) =>
        isEnabled &&
            formFactor.includes(currentFormFactor) &&
            segmentation(segmentationRules)
    , [currentFormFactor, segmentation]);
};
